import { Translation } from '@jsverse/transloco';

const en: Translation = {
  citizen: {
    loginToContinue: 'Login to Continue',
  },
  location: {
    province: 'Province',
    district: 'District',
    sector: 'Sector',
    cell: 'Cell',
    village: 'Village',
  },
  form: {
    title: {
      addCategory: 'Add Category',
      editCategory: 'Edit Category',
      addAccount: 'New Staff',
      editAccount: 'Edit Staff',
      addInstitution: 'New Institution',
      editInstitution: 'Edit Institution',
      editRole: 'Edit Role',
      newCase: 'New Case',
      editCase: 'Edit Case',
      newAnnouncement: 'New Announcement',
      editAnnouncement: 'Edit Announcement',
      newCitizen: 'New Citizen',
      editCitizen: 'Edit Citizen',
      anonymousComplaint: 'Anonymous Complaint',
      orientationLevel: 'Orientation Level',
      location: 'Assigned Location',
      locationDescription:
        'If no location is set, staff will handle cases in all areas',
      amountDescription: 'more selected',
      escalateCase: 'Escalate Case',
    },
    label: {
      kinyarwanda: 'Kinyarwanda',
      english: 'English',
      french: 'French',
      firstName: 'First Name',
      middleName: 'Middle Name',
      lastName: 'Last Name',
      documentType: 'Document',
      documentNumber: 'Document Number',
      name: 'Name',
      phoneNumber: 'Phone Number',
      gender: 'Gender',
      email: 'Email',
      nationalId: 'NID',
      province: 'Province',
      district: 'District',
      sector: 'Sector',
      cell: 'Cell',
      village: 'Village',
      title: 'Title',
      password: 'Password',
      description: 'Description',
      caseType: 'Case type',
      severity: 'Severity',
      victimsNumber: 'Number of victims',
      trackingLevel: 'Level',
      estimateDays: 'Estimated days',
      primaryOrganization: 'Primary Org',
      informedOrganization: 'Informed organizations',
      issueLocation: 'Location details',
      issueDetails: 'Details',
      orientationLevel: 'Case tracking level',
      recordingLevel: 'Recording Lvl',
      search: 'Search',
      goodGovernanceSection: 'Good Governance Section',
      complaint: 'Complaint',
      role: 'Role',
      occupation: 'Occupation',
      institution: 'Institution',
      from: 'From',
      to: 'To',
      roleValidity: 'Role validity (Optional)',
      roleValidityDescription:
        "This is the period where the role will be active, if not set it's set to indefinitely",
      assignPermission: 'Assign Permission',
      locationSearch: 'Select',
      organization: 'Organization',
      citizen: 'Citizen',
      reason: 'Reason this Complaint was Dismissed',
      reasonForEscalation: 'Reason for escalation',
      reasonMustBeAtLeast50Characters: 'Reason must be at least 50 characters',
      minimumCharacters: 'minimum characters',
      characters: 'characters',
    },
    placeholder: {
      documentType: 'Enter Document Type',
      documentNumber: 'Enter Document Number',
      name: 'Enter name',
      phoneNumber: 'Enter phone number',
      occupation: 'Enter occupation',
      gender: 'Select gender',
      email: 'Enter email',
      nationalId: 'Enter national ID',
      province: 'Select Province',
      district: 'Select district',
      sector: 'Select sector',
      cell: 'Select cell',
      village: 'Select village',
      password: 'Enter Password',
      description: 'Enter description',
      title: 'Enter Title',
      complaint: 'Enter complaint',
      caseType: 'Select case type',
      severity: 'Select severity level',
      victimsNumber: 'Select number of victims',
      trackingLevel: 'Select tracking level',
      estimateDays: 'Enter estimated days',
      primaryOrganization: 'Select primary organization',
      informedOrganization: 'Select informed organizations',
      issueLocation: 'Enter issue location details',
      issueDetails: 'Enter issue details',
      orientationLevel: 'Select case tracking level',
      recordingLevel: 'Select recording level',
      searchInstitution: 'Search here',
      firstName: 'Enter first name',
      lastName: 'Enter last name',
      institution: 'All Institution',
      search: 'Search here',
      noLocationsFound: 'No locations found',
      locationSearch: 'Select',
      organization: 'Select Organization',
      role: 'Select Role',
      explainWhyYouAreEscalatingThisCase:
        'Explain why you are escalating this case (minimum 50 characters)',
    },
    button: {
      forgotPassword: 'Forgot Password?',
      login: 'Login',
      resetPassword: 'Reset Password',
      alreadyHaveAnAccount: 'Already have an account?',
      submitButton: 'Submit',
      signUp: 'Sign up',
      ok: 'Okay',
      cancel: 'Cancel',
      addCategory: 'Add Category',
      editCategory: 'Edit Category',
      addAccount: 'Add Account',
      editAccount: 'Edit Account',
      addInstitution: 'Add Institution',
      editInstitution: 'Edit Institution',
      editRole: 'Edit Role',
      newCase: 'New Case',
      editCase: 'Edit Case',
      newAnnouncement: 'New Announcement',
      editAnnouncement: 'Edit Announcement',
      newCitizen: 'New Citizen',
      editCitizen: 'Edit Citizen',
      casesStatus: {
        closed: 'Closed',
        ongoing: 'Ongoing',
        done: 'Resolved',
        resolved: 'Resolved',
        reopened: 'Re-opened',
        re_opened: 'Re-opened',
      },
    },
    options: {
      severity: {
        low: 'Low',
        medium: 'Medium',
        high: 'High',
      },
      trackingLevel: {
        national: 'Nation',
        province: 'Province',
        district: 'District',
        sector: 'Sector',
        cell: 'Cell',
        village: 'Village',
      },
      victimsNumber: {
        one: 'One',
        multiple: 'Multiple',
      },
    },
    errors: {
      emailPhoneRequired: 'Email or Phone is required',
      passwordRequired: 'Password must be at least 8 characters',
      codeRequired: 'Verification code is required',
    },
  },
  resetPasswordForm: {
    title: 'Reset Your Password',
    description: 'Set a new password to continue and access the platform',
    label: {
      code: 'Old Password',
      newPassword: 'New Password',
    },
    placeholder: {
      code: 'Enter Old Password',
      enterNewPassword: 'Enter New Password',
    },
    button: 'Change To New Password',
  },
  casesStatus: {
    closed: 'Closed',
    ongoing: 'Ongoing',
    done: 'Resolved',
    resolved: 'Resolved',
    reopened: 'Re-Opened',
    pending: 'Pending',
  },
  announcementStatus: {
    published: 'Ryatangarijwe',
    unpublished: 'Ryarangiye',
  },
  noCasesFound: 'No cases found',
  fetchingData: 'Fetching data...',
  editPersonalInfo: 'Personal Info',
  editPersonalInfoDescription:
    'This information is being retrieved from your NID and cannot be edited',
  changePassword: ' Change Password',
  changePasswordDescription:
    'Enter your current password to change your password',
  currentPassword: 'Current Password',
  confirmPassword: 'Confirm Password',
  enterConfirmPassword: 'Enter Confirm Password',
  enterCurrentPassword: 'Enter Current Password',

  // MENU
  dashboard: 'Dashboard',
  complaints: 'Complaints',
  announcements: 'Announcements',
  tipOffs: 'TipOffs',
  manage: 'Manage',
  citizens: 'Citizens',
  institutions: 'Institutions',
  accounts: 'Accounts',
  security: 'Security',
  overview: 'Overview',
  cases: 'Cases',
  analytics: 'Analytics',
  staff: 'Staff',
  rolesAndPermissions: 'Roles & Permissions',
  systemSettings: 'System Settings',
  auditLog: 'Audit Log',
  tipOffCategories: 'TipOff Categories ',

  tipOffCategoryPage: {
    title: 'TipOff Categories',
    description: 'Manage tip-off categories',
    action: {
      addNewCategory: 'Add Category',
    },
  },
  modal: {
    title: 'Filter',
    byInstitution: 'By Institution',
    clear: 'Clear Filters',
    apply: 'Apply Filters',
    edit: 'Edit ',
    view: 'View ',
    deactivate: 'Deactivate',
    activate: 'Activate',
    delete: 'Delete',
  },
  noDocumentsFound: 'No Document Found',
  quickOverview: 'Quick Overview',
  landingPageTitle: 'Welcome to Mbaza',
  reportAnonymously: 'Report anonymously',
  home: 'Home',
  tipOffCategory: 'Category',
  tipOffCategoryPlaceholder: 'Select a tip-off category',
  myDashboard: 'My Dashboard',
  announcement: 'Announcements',
  newAnonymousComplaint: 'Report Anonymously',
  issueDescription: 'Issue Description',
  enterIssueDescription: 'Enter issue description',
  issueTitlePlaceholder: 'Enter issue title',
  welcome: 'Welcome',
  submitComplaint: 'Submit Complaint',
  submitComplaintButton: 'Submit a Complaint',
  newComplaint: 'New Complaint',
  closed: 'Closed',
  ongoing: 'Ongoing',
  nationalId: 'National ID',
  name: 'Name',
  phoneNumber: 'Phone Number',
  gender: 'Gender',
  email: 'Email',
  complaintsAndCases: 'Complaints & Cases',
  searchHere: 'Search here',
  underReview: 'Under review',
  myComplaints: 'My Complaints',
  statusOngoing: 'Ongoing',
  statusPending: 'Pending',
  statusReOpened: 'Re-opened',
  statusClosed: 'Closed',
  statusDone: 'Resolved',
  issueLocation: 'Issue Location',
  district: 'District',
  sector: 'Sector',
  cell: 'Cell',
  village: 'Village',
  selectDistrict: 'Select District',
  selectSector: 'Select Sector',
  selectCell: 'Select Cell',
  selectVillage: 'Select Village',
  issueDetails: 'Issue Details',
  title: 'Title',
  enterTitle: 'Enter title',
  complaint: 'Complaint',
  complaintTitle: 'Complaint Title',
  typeYourComplaint: 'Type your complaint',
  download: 'Download',
  noFilesAttached: 'No Files Attached',
  complaintDetails: 'Complaint Details',
  reportedOn: 'Reported on',
  close: 'Close',
  loading: 'Loading...',
  supportingAttachments: 'Supporting Attachments',
  caseDetails: 'Case Details',
  reportedBy: 'Reported by',
  informedInstitutions: 'Informed Institutions',
  noOrganizationsInformed: 'No organizations informed yet',
  caseTimeline: 'Case Timeline',
  trackingLevel: 'Recording Level',
  tracking: 'Tracking ',
  trackingPlaceholder: 'Enter tracking number',
  createdBy: 'Created By',
  assignedTo: 'Assigned To',
  primaryOrganization: 'Primary Organization',
  none: 'None',
  myProfile: 'My Profile',
  profile: 'Profile',
  logout: 'Logout',
  login: 'Login',
  trackComplaint: 'Track Complaint',
  trackAnotherComplaint: 'Track Another Complaint',
  reportedAComplaint: 'Reported a Complaint',
  createdACase: 'Created a Case',
  addedAComment: 'Added a Comment',
  tagged: 'Tagged',
  you: 'you',
  trackYourComplaint: 'Track Your Complaint',
  mostCasePerDistrict: 'Most cases per District',
  mostCasePerInstitution: 'Most cases per Institutions',
  mostCasePerCategory: 'Most cases per Category',
  caseTrendThisYear: 'Case Trend This Year',
  notifications: 'Notifications',
  newCase: 'New Case',
  createCase: 'Create Case',
  nonOrientedComplaints: 'Non-oriented Complaints',
  filterComplaints: 'Filter Complaints',
  today: 'Today',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  thisYear: 'This Year',
  allTime: 'All Time',
  enterNamesKeyword: 'Enter names, keyword, etc...',
  retry: 'Retry',
  urgentCases: 'Urgent Cases',
  urgent: 'Urgent',
  notUrgent: 'Not Urgent',
  nothingToShow: 'Nothing to show',
  thisListIsEmpty: 'This list is Empty',
  filter: 'Filter',
  allCases: 'All Cases',
  selectStatus: 'Select Status',
  selectCategory: 'Select Category',
  selectOwnership: 'Select Ownership',
  primaryCases: 'Primary Cases',
  secondaryCases: 'Secondary Cases',
  status: 'Status',
  type: 'Type',
  filterCases: 'Filter Cases',
  byProvince: 'By Province',
  byLocation: 'By Location',
  byPeriod: 'By Period',
  byStatus: 'By Status',
  byInstitutions: 'By Institutions',
  bySeverityAndUrgency: 'By Urgency',
  institution: 'Institution',
  severity: 'Severity',
  urgency: 'Urgency',
  ownership: 'Ownership',
  allStatus: 'All Status',
  allTypes: 'All Types',
  allOwnerships: 'All Ownerships',
  allProvinces: 'All Provinces',
  allDistricts: 'All Districts',
  allSectors: 'All Sectors',
  allCells: 'All Cells',
  allVillages: 'All Villages',
  allInstitutions: 'All Institutions',
  allSeverities: 'All Severities',
  allUrgencies: 'All Urgencies',
  clearFilters: 'Clear Filters',
  filterList: 'Filter List',
  dateRange: 'Date Range',
  period: 'Period',
  selectHere: 'Select here',
  mostCasesPerCategory: 'Most cases per Category',
  mostCasesPerInstitutions: 'Most cases per Institutions',
  mostCasesPerDistrict: 'Most cases per District',
  mostCasePerChannel: 'Most Case per Channel',
  noDataAvailable: 'No data available',
  totalCases: 'Total Cases',
  new: 'New',
  reopened: 'Re-Opened',
  avgReactionTime: 'Avg Reaction Time',
  reactionTimeDay: 'day',
  reactionTimeDays: 'days',
  reactionTimeHour: 'hour',
  reactionTimeHours: 'hours',
  reactionTimeAnd: 'and',
  avgSatisfaction: 'Avg Satisfaction',
  done: 'Resolved',
  casesTrendPerYear: 'Cases trend per year',
  casesOnTheMap: 'Cases on the Map',
  totalCitizens: 'Total Citizens',
  withOngoingCases: 'With ongoing cases',
  avgCasesPerUser: 'Avg cases per user',
  avgCasesPerInstitution: 'Avg cases per Institution',
  female: 'Female',
  male: 'Male',
  foreigners: 'Foreigners',
  newCitizen: 'New Citizen',
  createCitizen: 'Create Citizen',
  saveChanges: 'Save Changes',
  editCitizen: 'Edit Citizen',
  numberOfCases: 'Number of cases',
  totalInstitutions: 'Total Institutions',
  institutionsWithOngoingCases: 'Institutions with ongoing cases',
  newInstitution: 'New Institution',
  addInstitution: 'Add Institution',
  ongoingCases: 'Ongoing cases',
  joined: 'Joined',
  myCases: 'My Cases',
  taggedCases: 'Tagged Cases',
  organizationDetails: 'Organization Details',
  performance: 'Performance',
  admin: 'Admin',
  addStaff: 'Add Staff',
  newStaff: 'New Staff',
  systemAccounts: 'System Accounts',
  role: 'Role',
  lastLogin: 'Last Login',
  edit: 'Edit',
  addAccount: 'Add Account',
  addRole: 'Add Role',
  usedBy: 'Used by',
  roles: 'Roles',
  newRole: 'New Role',
  newAnnouncement: 'New Announcement',
  unpublish: 'Unpublish',
  expiresAt: 'Expires At',
  announcementTitle: 'Announcement Title',
  announcementValidity: 'Announcement Validity',
  expiryDate: 'Expiry Date',
  publishAnnouncement: 'Publish Announcement',
  yourAnnouncement: 'Your Announcement',
  announcementValidityDescription:
    "This is the period where the announcement will be active, if not set it's set to 5 days from the published date",
  published: 'Published',
  unpublished: 'Expired',
  reviewComplaint: 'Review Complaint',
  rating: 'Rating',
  commentsOptional: 'Comments (Optional)',
  shareYourFeedback: 'Share your feedback...',
  reporterReview: "Reporter's Review",
  register: 'Register',
  enterNationalId: 'Enter National ID',
  continue: 'Continue',
  haveAnAccount: 'Have an account?',
  selectYourPhoneNumber: 'Select your phone number',
  associatedPhoneNumbers: 'Associated phone numbers',
  requestVerificationCode: 'Request verification code',
  verificationCode: 'Verification code',
  verificationCodeDescription:
    'You have received a verification code on your phone {{ phone }}',
  verifyCode: 'Verify code',
  completeYourRegistration: 'Complete your Registration',
  completeRegistrationDescription:
    'Please provide the following information to complete your registration',
  firstName: 'First name',
  lastName: 'Last name',
  enterEmail: 'Enter email',
  password: 'Password',
  enterPassword: 'Enter password',
  signUp: 'Sign up',
  emailOrPhone: 'Email / Phone',
  enterEmailOrPhoneNumber: 'Enter Email or Phone Number',
  forgotPassword: 'Forgot Password?',
  resetPassword: 'Reset Password',
  createDefaultPassword: 'Create Temporary Password',
  defaultPassword: 'Temporary Password',
  enterDefaultPassword: 'Enter temporary password',
  defaultPasswordFor: 'Set a temporary password for',
  goToLogin: 'Go to Login',
  code: 'Code',
  enterCode: 'Enter Code',
  enterNewPassword: 'Enter New Password',
  newPassword: 'New Password',
  confirmPasswordReset: 'Confirm Password Reset',
  noNotificationsFound: 'No notifications found',
  mentionedYouInACommentOnCase: 'mentioned you in a comment on case',
  invitedYouToACase: 'invited you to a case',
  markAllAsRead: 'Mark all as read',
  caseNotAccessible: 'You do not have access to this case',
  caseNotAccessibleHint:
    'You were notified about this case, but it is outside your access scope. Ask the person who tagged you to invite your institution.',
  caseNotFound: 'Case not found',
  caseLoadFailed: 'The case could not be loaded',
  backToCases: 'Back to cases',
  selectInstitution: 'Select Institution',
  manageCaseCategoriesDescription:
    'Manage the available case categories and their descriptions.',
  caseCategories: 'Case Categories',
  addCaseCategory: 'Add Case Category',
  updateCaseCategory: 'Update Case Category',
  deleteCaseCategory: 'Delete Case Category',
  caseCategoryName: 'Case Category Name',
  caseCategoryDescription: 'Case Category Description',
  enterCaseCategoryName: 'Enter Case Category Name',
  enterCaseCategoryDescription: 'Enter Case Category Description',
  editAnnouncement: 'Edit Announcement',
  tipoffs: 'Tipoffs',
  institutionCases: 'Institution Cases',
  permissions: 'Permissions',
  caseCategoriesSettings: 'Case Categories Settings',
  notificationSettings: 'Notification Settings',
  notificationSettingsDescription:
    'Configure daily notifications of your cases and complaints.',
  addReportingNotification: 'Add Reporting Notification',
  createNotification: 'Create Notification',
  reportingNotificationHelperText:
    'Create reporting notifications by tracking level, assigned locations, and destination email.',
  smsNotifications: 'SMS Notifications',
  emailNotifications: 'Email Notifications',
  notificationChannelDescription:
    'Enable or disable this notification channel for your account.',
  selectRecordingLevel: 'Select recording level',
  selectOrganization: 'Select organization',
  assignedLocations: 'Assigned Locations',
  searchAssignedLocations: 'Search assigned locations',
  enterNotificationEmail: 'Enter notification email',
  assignedLocationRequired: 'At least one location is required',
  createdAt: 'Created At',
  description: 'Description',
  refreshAnalytics: 'Refresh Analytics',
  analyticsRefreshed: 'Analytics refreshed successfully',
  errorRefreshingAnalytics: 'Error refreshing analytics',
  organization: 'Organization',
  occupation: 'Occupation',
  private: 'Private',
  noTimestamp: 'No timestamp',
  theCaseWasMarkedAs: 'The case was marked as',
  theCaseWasEscalatedTo: 'The case was escalated to',
  escalatedTheCaseTo: 'escalated the case to',
  rejectComplaint: 'Dismiss Complaint',
  closeComplaint: 'Close Complaint',
  confirmClose: 'Confirm',
  addAComment: 'Add a comment',
  commentIsRequired: 'Comment is required',
  thisCommentWillBeRecordedWithTheComplaintClosure:
    'This comment will be recorded with the complaint closure',
  explainWhyThisComplaintIsBeingClosed:
    'Explain why this complaint is being dismissed',
  minimum: 'Minimum',
  characters: 'characters',
  comment: 'Comment',
  reported: 'reported a complaint.',
  createACase: 'created a case.',
  markedAs: 'The case was marked as',
  escalated: 'escalated the case to',
  charactersCount: 'Character Count',
  systemConfiguration: {
    title: 'How would you like to receive notification',
    description: ' Edit notification preferences',
    label: 'System Configuration',
  },
  markAs: 'MARK AS',
  success: 'Success',
  all: 'All',
  totalSubmittedComplaints: 'Total Submitted Complaints',
  rejectedComplaints: 'Dismissed Complaints',
  isAcknowledged: 'Acknowledgement',
  acknowledgedComplaints: 'Acknowledged Complaints',
  pendingComplaints: 'Pending Complaints',
  loadMore: 'Load More ',
  totalRatings: 'Total Ratings',
  orientedCases: 'Oriented Cases',
  dismissedComplaints: 'Dismissed Complaints',
  avgComplaintsPerDay: 'Avg Complaints Per Day',
  casesActivity: 'Oriented vs Non-Oriented Complaints',
  casesActivityDescription:
    'Received complaints breakdown by activity (Oriented vs Non-Oriented vs Dismissed)',
  casesPerLocation: 'Distribution of Complaints Across Locations',
  casesPerLocationDescription:
    'Received complaints breakdown by location in your jurisdiction',
  casesPerLocationRanking: 'Top 5 Locations by Unoriented Complaints',
  casesPerLocationRankingDescription:
    'Ranking of locations by the number of complaints received but not oriented (Top 5 locations)',
  allLocationsOrientedComplaints:
    'All locations have oriented their complaints',
  orientedCasesPerStatus: 'Orientation Outcome by Status',
  orientedCasesPerStatusDescription:
    'Received complaints breakdown by status (Open, Closed, Reopened, Resolved, Rejected)',
  orientedCasesPerLocation: 'Distribution of Oriented Cases Across Locations',
  orientedCasesPerLocationDescription:
    'Received complaints breakdown by location in your jurisdiction',
  orientedCasesPerLocationRanking: 'Top 5 Locations by Oriented Complaints',
  orientedCasesPerLocationRankingDescription:
    'Ranking of locations by the number of complaints oriented (Top 5 locations)',
  accountsUsage: 'Active vs Inactive Accounts',
  accountsUsageDescription:
    'Usage of accounts in your jurisdiction. Active accounts are those that have logged in at least once in the last 5 days.',
  activeAccountsByRole: 'Active Complaints Officer Accounts',
  activeAccountsByRoleDescription:
    'Ranking of roles by the number of active complaints officer accounts (excluding other staff accounts)',
  noActiveAccountsByRole: 'No active accounts found',
  accountsPerLocation: 'Accounts Accross Locations',
  accountsPerLocationDescription:
    'Distribution of accounts by locations in your jurisdiction',
  complaintStatistics: 'Complaint Statistics',
  complaintStatisticsDescription:
    'Statistics of complaints and channels used to submit complaints',
  active: 'Active',
  inactive: 'Inactive',
  platformStatistics: 'System Usage Statistics',
  resolved: 'Resolved',
  nonOriented: 'Non-Oriented',
  oriented: 'Oriented',
  dismissed: 'Dismissed',
  province: 'Province',
  filterByLocation: 'Filter by Location',
  escalationNote: 'Escalation Note',
  officerComment: "Officer's Comment",
  chatAssistant: {
    title: 'Mbaza Assistant',
    subtitle: 'Ask questions about your data',
    emptyGreeting:
      'Ask me anything about citizen complaints, staff activity, or district performance.',
    placeholder: 'Ask about complaints, trends...',
    send: 'Send',
    error: "Sorry, I couldn't get an answer. Please try again.",
    toastError: 'Failed to get a response from the assistant',
    openAriaLabel: 'Open chat assistant',
    closeAriaLabel: 'Close chat assistant',
    suggestions: {
      locationPerformance: 'How is my location doing in terms of complaints?',
      staffLogins: 'How many staff have logged in the past month?',
      unresolvedByDistrict:
        'Which district has the most unresolved complaints?',
      avgResolutionTime: 'What is the average complaint resolution time?',
      emergingTrends: 'Are there any emerging complaint trends this week?',
    },
  },
};

export default en;
